import React from 'react';

import Checkbox from 'components/shared/FormAdapters/FormDefault/CheckBox';
import { FLIGHTS } from 'constants/texts';

import s from './index.module.css';

const NotificationCheckboxes = ({
  isNotifyAgentChecked,
  isUpdateClientSideChecked,
  setIsNotifyAgentChecked,
  setIsUpdateClientSideChecked,
}: {
  isNotifyAgentChecked: boolean;
  isUpdateClientSideChecked: boolean;
  setIsNotifyAgentChecked: () => void;
  setIsUpdateClientSideChecked: () => void;
}) => {
  return (
    <div className={s.notifications}>
      <Checkbox
        checked={isNotifyAgentChecked}
        onChange={setIsNotifyAgentChecked}
        noMargin
        centered
        titleClassName={s.text}
      >
        {FLIGHTS.CHECKBOXES.NOTIFY}
      </Checkbox>
      <Checkbox
        checked={isUpdateClientSideChecked}
        onChange={setIsUpdateClientSideChecked}
        noMargin
        titleClassName={s.text}
      >
        {FLIGHTS.CHECKBOXES.UPDATE}
      </Checkbox>
    </div>
  );
};

export default NotificationCheckboxes;
